import { useLocation } from 'react-router-dom';
import { parse } from 'search-params';

// Adapted from https://reacttraining.com/react-router/web/example/query-parameters
export const useQuery = () => {
  return parse(useLocation().search);
};
